<template>
    <div :class="['resources_manager', visible ? 'visible' : 'invisible']">
        <div class="header">资源管理器 <i @click.stop="hideMenu" class="iconfont iconguanbi"></i></div>
        <div class="body">
            <el-tree :data="data" node-key="id" :expand-on-click-node="false" :default-expanded-keys="[4]" ref="tree">
                <div :class="['custom-tree-node', data.id == selectedId ? 'active-tree' : '' ]" slot-scope="{ node, data }">
                    <span class="l">
                        <i v-show="data.type == 0" class="iconfont icontucengzu_guan"></i>
                        <i v-show="data.type == 1" class="iconfont iconjiechufenzu"></i>
                        <span @click="selectModel(data.mid)">{{node.label}}</span>
                    </span>
                    <span v-show="data.type !== 0" class="r">
                        <template v-if="data.type != 3">
                            <i @click.stop="toggleLock(node)" v-if="data.lock" class="iconfont iconsuoding1"></i>
                            <i @click.stop="toggleLock(node)" v-else class="iconfont iconsuoding1"></i>
                        </template>
                        <i @click.stop="toggleVisible(node)" v-if="data.visiable" class="iconfont iconyulan"></i>
                        <i @click.stop="toggleVisible(node)" v-else class="iconfont iconbiyanjing"></i>
                    </span>
                </div>
            </el-tree>
        </div>
        <div class="footer">
            <span @click.stop="toDelete"><i class="iconfont iconshanchu"></i> 删除</span>
        </div>
    </div>
</template>

<script>
import BusEvent from '@/busEvent'

var sceneChangeHandler, selectedChangeHandler

export default {

    props: {
        visible: {
            default: false
        }
    },

    data() {
        return {
            data: [],
            selectedId: ''
        }
    },

    computed: {
        viewer(){
            return window.viewer
        }
    },

    mounted(){
        this.sceneChangeHandler()
        sceneChangeHandler = this.sceneChangeHandler.bind(this)
        selectedChangeHandler = this.selectedChangeHandler.bind(this)
        this.$bus.$on( BusEvent.SceneChange, sceneChangeHandler )
        this.$bus.$on( BusEvent.SelectedChange, selectedChangeHandler )
        this.viewer.addEventListener( AMRT.Event.MAP_MODEL_INITED, sceneChangeHandler )
    },

    beforeDestroy(){
        this.$bus.$off(BusEvent.SceneChange, sceneChangeHandler)
        this.$bus.$off(BusEvent.SelectedChange, selectedChangeHandler)
        this.viewer.removeEventListener( AMRT.Event.MAP_MODEL_INITED, sceneChangeHandler )
    },

    methods: {

        sceneChangeHandler(){
            var group = {
                id: 4,
                type: 0,
                label: '模型文件夹',
                children: this.parseResourcesTree( this.viewer.modelGroup.children )
            }
            this.data = [ group ]
        },

        parseResourcesTree( group ){
            var data = []
            group.map(m => {
                if( m.isGroup ){
                    let children = this.parseResourcesTree( m.children )
                    let item = {
                        id: m.uuid,
                        label: m.name,
                        mid: m.id,
                        type: 1,
                        visiable: true,
                        lock: false,
                        children
                    }
                    data.push( item )
                }else{
                    let item = {
                        id: m.uuid,
                        label: m.modelName,
                        mid: m.id,
                        type: 2,
                        visiable: true,
                        lock: false
                    }
                    data.push( item )
                }
            })
            return data
        },

        selectModel( id ){
            if( id === undefined ) return
            let selected = this.viewer.root.getObjectById( id )
            this.viewer.controls.fit( selected )
            if( !selected.isLargeScene ){
                this.viewer.selectedObject = [ selected ]
            }else{
                this.viewer.selectedObject = []
                setTimeout(() => {
                    selected.loader.detect()
                }, 1000);
            }
            this.$parent.selectedNum = this.viewer.selectedObject.length
            this.$bus.$emit( BusEvent.SelectedChange )
        },

        toggleVisible( node ){
            if( node.data.type == 3 ){
                if( node.data.label == '白模建筑' ){
                    this.viewer.tilesGroup.visible = !this.viewer.tilesGroup.visible
                    node.data.visiable = this.viewer.tilesGroup.visible
                }
            }else{
                let selected = this.viewer.root.getObjectById( node.data.mid )
                selected.visible = !selected.visible
                node.data.visiable = selected.visible
            }
        },

        toggleLock( node ){
            let selected = this.viewer.root.getObjectById( node.data.mid )
            selected.lock = !selected.lock
            node.data.lock = selected.lock
        },

        selectedChangeHandler(){
            if( this.viewer.selectedObject.length === 1 ){
                let node = this.$refs.tree.getNode(this.viewer.selectedObject[0].uuid)
                node && ( node.expanded = true )
                this.selectedId = this.viewer.selectedObject[0].uuid
            }else{
                this.selectedId = ''
            }
        },

        hideMenu(){
            this.$emit('hide', false)
        },

        toDelete(){
            this.$parent.deleteModel()
        }
    }
}
</script>

<style lang="scss" scoped>
.resources_manager{
    width: 220px; height: 700px; overflow: scroll; background-color: #F2F4F6; position: fixed;  top: 120px; z-index: 1; border-radius: 5px; transition: left 1s;
    .header{ 
        padding: 0 10px; height: 34px; line-height: 34px; width: 100%; font-size: 14px; font-weight: normal; background-color: #fff;
        .iconfont{ position: absolute; right: 10px; font-size: 14px; cursor: pointer; color: #182C49; }
    }
    .body{
        height: 632px; width: 100%; border-top: 1px solid #E0E2E3; overflow-y: scroll; scrollbar-width: none; /* Firefox */
        &::-webkit-scrollbar {
            display: none; /* Chrome Safari */
        }
        /deep/ .el-tree-node__content{ height: 34px; }
        .custom-tree-node{
            display: flex; justify-content: space-between; align-items: center; padding-right: 10px; width: 100%; cursor: auto; height: 34px; 
            .l{
                .iconfont{margin-right: 5px;} 
                span{cursor: pointer; &:hover{color: #1458EA;}}
            }
            .r{
                .unselected{ display: inline-block; width: 14px; height: 14px; border: 1px solid #aaa; border-radius: 3px; position: relative ; top: 3px; cursor: pointer; margin-left: 6px; }
                .iconfont{
                    margin-left: 6px;
                    &:hover{ color: #1458EA; }
                }
            }
            .iconfont{cursor: pointer;}
        }
        /deep/ .el-tree{background-color: transparent;}
        .active-tree{
            .l{
                .iconfont, span{ color: #1458EA; }
            }
        }
    }
    .footer{
        padding: 0 10px; height: 34px; line-height: 34px; width: calc( 100% - 20px); font-size: 14px; font-weight: normal; background-color: #fff; display: flex; justify-content: center; align-items: center;
        span{cursor: pointer; color: #182C49; &:hover{color: #1458EA;}}
    }
    &::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }
}
.invisible{ left: -230px; }
.visible{ left: 10px; }
</style>